export default __webpack_public_path__ + "static/media/quiz_bg_small.7b6684f0.png";